<template>
    <div>
        <div class="row justify-content-between">
            <div class="col-4">
                <p class="theme-search-results-item-flight-section-meta-date text-MINT">
                    <span v-if="getFormattedDate(cargo.time + '000') >= 0 &&
                        getFormattedDate(cargo.time + '000') <= 15
                        ">
                        دقایقی قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 16 &&
                        getFormattedDate(cargo.time + '000') <= 30
                        ">
                        یک ربع پیش
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 31 &&
                        getFormattedDate(cargo.time + '000') <= 45
                        ">
                        نیم ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 46 &&
                        getFormattedDate(cargo.time + '000') <= 60
                        ">
                        1 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 61 &&
                        getFormattedDate(cargo.time + '000') <= 121
                        ">
                        2 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 122 &&
                        getFormattedDate(cargo.time + '000') <= 182
                        ">
                        3 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 183 &&
                        getFormattedDate(cargo.time + '000') <= 243
                        ">
                        4 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 244 &&
                        getFormattedDate(cargo.time + '000') <= 304
                        ">
                        5 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 305 &&
                        getFormattedDate(cargo.time + '000') <= 365
                        ">
                        6 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 366 &&
                        getFormattedDate(cargo.time + '000') <= 426
                        ">
                        7 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 427 &&
                        getFormattedDate(cargo.time + '000') <= 487
                        ">
                        8 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 488 &&
                        getFormattedDate(cargo.time + '000') <= 548
                        ">
                        9 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 549 &&
                        getFormattedDate(cargo.time + '000') <= 609
                        ">
                        10 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 610 &&
                        getFormattedDate(cargo.time + '000') <= 670
                        ">
                        11 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 671 &&
                        getFormattedDate(cargo.time + '000') <= 731
                        ">
                        12 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 732 &&
                        getFormattedDate(cargo.time + '000') <= 792
                        ">
                        13 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 793 &&
                        getFormattedDate(cargo.time + '000') <= 853
                        ">
                        14 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 854 &&
                        getFormattedDate(cargo.time + '000') <= 914
                        ">
                        15 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 915 &&
                        getFormattedDate(cargo.time + '000') <= 975
                        ">
                        16 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 976 &&
                        getFormattedDate(cargo.time + '000') <= 1036
                        ">
                        17 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1037 &&
                        getFormattedDate(cargo.time + '000') <= 1095
                        ">
                        18 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1096 &&
                        getFormattedDate(cargo.time + '000') <= 1156
                        ">
                        19 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1157 &&
                        getFormattedDate(cargo.time + '000') <= 1217
                        ">
                        20 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1218 &&
                        getFormattedDate(cargo.time + '000') <= 1278
                        ">
                        21 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1279 &&
                        getFormattedDate(cargo.time + '000') <= 1339
                        ">
                        22 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1340 &&
                        getFormattedDate(cargo.time + '000') <= 1400
                        ">
                        23 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1401 &&
                        getFormattedDate(cargo.time + '000') <= 1461
                        ">
                        24 ساعت قبل
                    </span>
                    <span v-if="getFormattedDate(cargo.time + '000') >= 1462 &&
                        getFormattedDate(cargo.time + '000') <= 2500
                        ">
                        1 روز پیش
                    </span>
                </p>
            </div>
            <div class="col-4 w-auto d-flex justify-content-end">
                <span class="ribbon" v-if="getFormattedDate(cargo.time + '000') <= 60">جدید</span>
                <span v-if="cargo.userType == 'owner' && cargo.isBot == '0'" class="new">فوری</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['cargo'],
    methods: {
        getFormattedDate(dates) {
            var myDate = new Date();
            // var offset = myDate.getTimezoneOffset() * 60 * 1000;
            var withOffset = myDate.getTime();
            // console.log(withOffset);
            // var withoutOffset = withOffset - offset;
            var current = withOffset - dates;
            // console.log(current);
            const minutes = Math.floor(current / 1000 / 60);
            // console.log(minutes);
            return minutes;
        }
    }
}
</script>
<style></style>